<template>
  <div>
    <div
      v-if="!loading"
      class="output-format d-xl-flex justify-content-xl-evenly py-xl-3"
    >
      <resume-global :objDTO="objDTO" />

      <div class="output-group">
        <div class="output-title">
          <b>Dados do Sinistro</b>
        </div>

        <div>
          <span>Data / Hora Sinistro:</span>
          {{ sinistroData() }}
        </div>
        <div class="output-textArea">
          <span>O que aconteceu:</span>
          {{ objDTO.Sinistro.SinistroDescricao }}
        </div>
        <div>
          <span>Cobertura:</span>
          {{ coverageDesc() }}
        </div>
        <div>
          <span>Evento:</span>
          {{ eventDesc() }}
        </div>
        <div v-if="objDTO.Sinistro.DataAdmissao">
          <span>Data Admissão:</span>
          {{ dataAdmissao() }}
        </div>
      </div>
    </div>
    <div v-if="!loading" class="col-12 Aligner aligner-right">
      <button
        class="button-base-small btn-gray font-small mx-1"
        @click="voltar"
      >
        Voltar
      </button>
      <button
        class="button-base-small btn-green font-small mx-1"
        @click="finishAviso"
         :disabled="loading"
      >
        Concluir Aviso
      </button>
    </div>
    <loading-state-f-s v-else />
  </div>
</template>

<script>
import { createAviso } from '../../api/formMethods';
import {
  getDescriptionFromArrayById,
  formatDate,
  formatDisplayDateOnly,
  formatDisplayDateTime,
  handleAberturaResponseWithUploadDocuments,
} from '../../utils/helpers';
import ResumeGlobal from '../ResumeGlobal.vue';
import LoadingStateFS from '../LoadingStateFS.vue';
import { AREA_NEGOCIO } from '../../utils/constants';

export default {
  components: {
    ResumeGlobal,
    LoadingStateFS,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    objDTO: Object,
    events: Array,
    coverages: Array,
    riskUnits: Array,
    insuranceObjects: Array,
  },
  methods: {
    sinistroData() {
      return formatDisplayDateTime(this.objDTO.Sinistro.SinistroData);
    },
    dataAdmissao() {
      return formatDisplayDateOnly(this.objDTO.Sinistro.DataAdmissao);
    },
    eventDesc() {
      return getDescriptionFromArrayById(
        this.events,
        this.objDTO.Sinistro.SinistroEventoId,
        'Id'
      );
    },
    coverageDesc() {
      return getDescriptionFromArrayById(
        this.coverages,
        this.objDTO.Apolice.ApoliceCoberturaId,
        'GisCoverageId'
      );
    },
    async finishAviso() {
      this.loading = true;
      try{
        this.objDTO.FormAvisoId = 6;

      this.objDTO.Sinistro.SinistroData = formatDate(
        this.objDTO.Sinistro.SinistroData
      );
      this.objDTO.Sinistro.ApoliceDataInicio = formatDate(
        this.objDTO.Sinistro.ApoliceDataInicio
      );
      this.objDTO.Sinistro.ApoliceDataFim = formatDate(
        this.objDTO.Sinistro.ApoliceDataFim
      );
      this.objDTO.Sinistro.DataNascimento = formatDate(
        this.objDTO.Sinistro.DataNascimento
      );

      // Descricoes
      this.objDTO.Apolice.UnidadeDeRiscoDescricao = getDescriptionFromArrayById(
        this.riskUnits,
        this.objDTO.Apolice.UnidadeDeRiscoExternalId,
        'RiskUnitId'
      );
      this.objDTO.Apolice.ObjectoSeguradoDescricao = getDescriptionFromArrayById(
        this.insuranceObjects,
        this.objDTO.Apolice.ObjectoSeguradoExternalId,
        'InsuranceObjectId'
      );

      const response = await createAviso(this.objDTO, this.coverages);

      handleAberturaResponseWithUploadDocuments(
        response,
        AREA_NEGOCIO.AfinidadesDemaisProdutos
      );
      }
      catch (error) {
        this.loading = false;
        console.error(error);
      }
      finally {
        this.loading = false;
      }
    },
    voltar() {
      this.$emit('back', 1);
    },
  },
};
</script>
